import React from "react";
import When from "../../common/components/When";
import classNames from "classnames";
import Label from "../../common/components/Label";


const ProducedOn = (props) => (
    <div className={classNames("pure-control-group", props.className)}>
        <Label htmlFor="producedOn">Produced on</Label>
        <When id="disseminatedOn" {...props} />
    </div>
);
ProducedOn.propTypes = {
    className: React.PropTypes.string
};

export default ProducedOn;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/ProducedOn.js
 **/